export default __webpack_public_path__ + "static/Innovation-5c5572960e625f44f55ba7a03ad24f0c.mp4";